import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft, LogOut } from 'lucide-react';

export default function AdminNav({ title, subtitle, backPath = '/admin/dashboard' }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <nav className="bg-white border-b border-gray-100 shadow-sm sticky top-0 z-20">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(backPath)}
            className="text-gray-400 hover:text-gray-600 transition p-1 rounded-lg hover:bg-gray-100">
            <ArrowLeft className="h-5 w-5" />
          </button>
          <img src="/logo-horizontal.png" alt="ShramSena" className="h-7 w-auto" />
          <span className="px-2 py-0.5 bg-red-100 text-red-700 rounded-lg text-xs font-bold uppercase tracking-wide">Admin</span>
        </div>
        <div className="flex-1 text-center hidden sm:block">
          <p className="text-sm font-bold text-slate-800 leading-tight">{title}</p>
          {subtitle && <p className="text-xs text-gray-400">{subtitle}</p>}
        </div>
        <div className="flex items-center gap-4">
          <span className="hidden md:block text-sm font-medium text-slate-600">{user?.firstName}</span>
          <button onClick={() => { logout(); navigate('/login'); }}
            className="flex items-center gap-1.5 text-sm font-medium text-red-500 hover:text-red-700 transition">
            <LogOut className="h-4 w-4" /><span className="hidden sm:block">Logout</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
